module.exports = "/static/assets/59bec17a687a56c251f423378f05cb72.gif";